<template>
  <modal :title="title" size="xs" ref="modal">
    <account-loader :account-id="user.accountId" v-model="account" />
    <form v-if="account" class="q-gutter-md">
      <q-input label="First Name" v-model="local.firstName" outlined />
      <q-input label="Last Name" v-model="local.lastName" outlined />
      <q-input label="Email" type="email" :model-value="local.email" outlined disable />
      <select-role :account-type="account.type" v-model="local.role" outlined object />
    </form>
    <template v-slot:actions>
      <async-btn label="Save" color="primary" :task="task" @click="save" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { User, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import SelectRole from '@/role/SelectRole.vue';
import { Account } from '@/iam/types';
import AccountLoader from '@/iam/account/AccountLoader.vue';
import { edit } from './user';

interface Data {
  local: User,
  account: Account|null,
  task: Promise<void>|null,
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    AccountLoader,
    Modal,
    SelectRole,
    AsyncBtn,
  },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      local: { ...this.user },
      account: null,
      task: null,
    };
  },
  computed: {
    title(): string {
      return `${this.local.firstName} ${this.local.lastName}`;
    },
  },
  methods: {
    save() {
      this.task = edit(this.local);
      this.task.then(() => {
        this.$emit('ok', this.local);
        (this.$refs.modal as ModalElement).hide();
        notify('User details saved.');
      });
    },
  },
});
</script>
